const translations = {
    ASSETS: {
        RESOURCES_GROUP_LABEL: 'Resources',
        STAFF_GROUP_LABEL: 'Staff',
        LOCATIONS_GROUP_LABEL: 'Locations'
    },
    MODEL: {
        PAGINATION: {
            SUMMARY: 'SUMMARY TODO' //CORE.PAGINATION.SUMMARY $translate.instant('CORE.PAGINATION.SUMMARY', {start, end, total}); TODO !!!
        },
        EVENT_CHAIN: {
            ADMITTANCE: 'Admittance'
        },
        BASKET_ITEM: {
            ADMITTANCE: 'Admittance'
        },
        EVENT: {
            JOIN_WAIT_LIST: 'Join waitlist',
            SPACES_LEFT: 'SPACES_LEFT TODO' //CORE.EVENT.SPACES_LEFT  $translate.instant('CORE.EVENT.SPACES_LEFT', {N: left}, 'messageformat'); TODO !!!
        }
    }
};

export {
    translations
}